import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import mixpanel from 'mixpanel-browser';
import { getDefaultMixpanelProps, getUser } from '../service/authService';
import store from '../redux/store';

const SessionTracker = () => {
  const user = getUser();
  const location = useLocation();
  const prevPathRef = useRef(null);

  const detectPlatform = () => {
    const ua = navigator.userAgent;
    if (/Mobi|Android/i.test(ua)) return 'Mobile';
    if (/Tablet|iPad/i.test(ua)) return 'Tablet';
    return 'Web';
  };

  // const orgId = user?.['custom:organizationId'];
  // if (orgId === '5' && process.env.REACT_APP_STAGE === 'prod') {
  mixpanel.init(process.env.REACT_APP_MIXPANEL_KEY, {
    persistence: 'localStorage', // Stores Mixpanel IDs & session info in localStorage instead of cookies
    record_sessions_percent: 50,
    record_idle_timeout_ms: 600000, // 10 min
    record_max_ms: 900000, // 15 min
    record_heatmap_data: true,
    // debug: true, // Shows logs in dev console
  });
  // } else {
  //   mixpanel.init(process.env.REACT_APP_MIXPANEL_TEST_KEY, {
  //     // debug: true, // Shows logs in dev console
  //   });
  // }

  useEffect(() => {
    mixpanel.identify(user?.sub);
    // profile properties
    const firstName = user?.given_name || '';
    const lastName = user?.family_name || '';
    const fullName = [firstName, lastName].filter(Boolean).join(' ');
    mixpanel.people.set({
      $name: fullName || user?.email, // overwrite with correct value
      $email: user?.email,
      language: user?.['custom:language'],
    });
    // Super properties - automatically sent with every tracked event
    mixpanel.register({
      user: user?.sub,
      firstName: user?.given_name,
      lastName: user?.family_name,
      email: user?.email,
      platform: detectPlatform(),
    });
  }, [user?.sub]);

  // useEffect(() => {
  //   // Track session start
  //   const startTime = Date.now();
  //   sessionStorage.setItem('sessionStart', startTime.toString());

  //   mixpanel.track('Session Start', {
  //     // path: location.pathname,
  //     firstName: user?.given_name,
  //     lastName: user?.family_name,
  //     email: user?.email,
  //     user: user?.sub,
  //   });

  //   // Track session end
  //   const handleBeforeUnload = () => {
  //     const endTime = Date.now();
  //     const duration =
  //       endTime - Number(sessionStorage.getItem('sessionStart') || endTime);

  //     mixpanel.track('Session End', {
  //       duration_sec: Math.floor(duration / 1000),
  //       firstName: user?.given_name,
  //       lastName: user?.family_name,
  //       email: user?.email,
  //       user: user?.sub,
  //     });
  //   };

  //   window.addEventListener('beforeunload', handleBeforeUnload);

  //   return () => {
  //     window.removeEventListener('beforeunload', handleBeforeUnload);
  //   };
  // }, []);

  // Track referrer globally as default Referrer property gives login url most of the time due hard reload logics for re-direction
  useEffect(() => {
    // Before switching to the new page, React runs the cleanup of the previous effect, storing the previous URL in prevPathRef
    return () => {
      if (!location.pathname.includes('/login')) {
        prevPathRef.current = location.pathname; // update AFTER component unmount (for next render)
      }
    };
  }, [location]);

  // Expose referrer globally
  window.getReferrerPage = () => prevPathRef.current;
};

export default SessionTracker;

// Wrapper function for mixpanel.track() to centralize any conditional logic like comparing isMixpanelEnabled
export const trackMixPanelEvent = ({ eventName, props = {} }) => {
  const isMixpanelEnabled =
    store.getState().omniProfile?.profileDetail?.fetchProfileDetails?.data
      ?.isMixpanelEnabled;

  if (!isMixpanelEnabled) return; // skip tracking if isMixpanelEnabled flag is not true
  const referrerPage = window.getReferrerPage();
  mixpanel.track(eventName, {
    ...getDefaultMixpanelProps(),
    ...props, // overwrite only applicable ones
    referrer_page: referrerPage || 'NA',
  });
};
